/* eslint-disable react/default-props-match-prop-types */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FC, HTMLAttributes } from 'react';
import { styled } from 'linaria/react';
import { ConfirmationFieldInputs } from '@shared/ui/organisms';
import { withTheme } from '@shared/lib/theme';
export interface ConfirmationFieldProps extends Omit<HTMLAttributes<HTMLDivElement>, 'onChange'> {
  fieldsCount?: number;
  fieldWidth?: number;
  fieldHeight?: number;
  type?: string;
  /**
   * Массив со значиями инпутов по-умолчанию
   */
  initialValues?: Array<string>;
  isErrorAutoClearEnabled?: boolean;
  isLoading?: boolean;
  onComplete?: (code: string, showErr: (text: string) => void) => void;
  onChange?: (value: string) => void;
  autoFocus?: boolean;
  autoComplete?: string;
  isDisabled?: boolean;
  variant?: 'default' | 'premiumBanking';
  /**
   * Проп для прозрачности инпутов, в случае если цвет фона не белый
   */
  bgLayer?: boolean;
  hasError?: boolean;
  errorMessage?: string;
}

// отрефакторить
const ConfirmationField: FC<ConfirmationFieldProps> = ({
  fieldWidth,
  fieldHeight,
  type,
  onComplete,
  onChange,
  fieldsCount,
  isErrorAutoClearEnabled,
  isLoading,
  isDisabled,
  initialValues,
  autoFocus,
  autoComplete,
  variant,
  bgLayer,
  hasError,
  errorMessage
}) => <FieldWrapper>
    <ConfirmationFieldInputs fieldsCount={fieldsCount} type={type} fieldWidth={fieldWidth} fieldHeight={fieldHeight} onComplete={onComplete} onChange={onChange} isErrorAutoClearEnabled={isErrorAutoClearEnabled} isLoading={isLoading} isDisabled={isDisabled} initialValues={initialValues} autoFocus={autoFocus} autoComplete={autoComplete} variant={variant} bgLayer={bgLayer} hasError={hasError} errorMessage={errorMessage} />
  </FieldWrapper>;
export default ConfirmationField;
ConfirmationField.defaultProps = {
  className: undefined,
  fieldsCount: 4,
  fieldWidth: 32,
  fieldHeight: 38,
  type: 'number',
  initialValues: [],
  isErrorAutoClearEnabled: true,
  isLoading: false,
  onChange: undefined,
  autoFocus: false,
  autoComplete: 'one-time-code',
  variant: 'default',
  bgLayer: false,
  hasError: false,
  errorMessage: ''
};
const FieldWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "FieldWrapper",
  class: "f1gztqwh",
  propsAsIs: false
}));

require("./ConfirmationField.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./ConfirmationField.tsx");